<template>
  <w-toolbar shadow>
    <font-awesome-icon class="ma2" color="#54b946" icon="circle" />

    <div class="title3 nohref"><router-link to="/">Инициатива β</router-link></div>
    <div class="spacer"></div>
    <template v-for="menuEntry in menuItems().reverse()" :key="menuEntry.label">
      <div class="nohref smd-hide">
        <router-link v-bind:to="menuEntry.route" v-if='menuEntry.route'>
          {{ menuEntry.label }}
        </router-link>

        <a v-bind:href="menuEntry.href" v-else>
          {{ menuEntry.label }}
        </a>
      </div>
      <w-divider vertical class="mx2 smd-hide" v-if="!menuEntry.lastElement"></w-divider>
    </template>
    <w-button @click="openDrawer = true" bg-color="green" class="mdu-hide">
      <font-awesome-icon color="white" icon="bars" />
    </w-button>
  </w-toolbar>
  <w-drawer v-model="openDrawer" bottom height="150px">
    <w-flex column class="align-left justify-center">
      <w-list :items="menuItems()" hover color="primary">
        <template #item="{ item }">
          <router-link v-bind:to='item.route' v-if="item.route" @click="openDrawer = false"  style="color:black;">
            <font-awesome-icon class="mr3 ml3" v-bind:icon="item.icon" />
            <span style="font-size: 14px;" >{{ item.label }}</span>
          </router-link>

          <a v-bind:href='item.href' class="nolink" style="color:black;" v-else >
            <font-awesome-icon class="mr3 ml3" v-bind:icon="item.icon" />
            <span style="font-size: 14px;">{{ item.label }}</span>
          </a>
        </template>
      </w-list>

      <w-button @click="openDrawer = false" outline>
        Закрыть
      </w-button>
    </w-flex>

  </w-drawer>

</template>

<script>
export default {
  name: 'Header',
  props: {
    user: Object
  },
  data: function () {
    return {
      openDrawer: false,
      links: [
        {label: 'Предложить инициативу', route: '/initiative/new', icon: 'plus-square'},
        {label: 'Для чего этот сервис?', route: '/about', icon: 'book'}
      ],
      unauthorized: {label: 'Войти в учетную запись', href: 'https://account.misis.club/?return=' + window.location.href, icon: 'sign-in-alt', lastElement: true},
      authorized: {label: this.user.authorized ? this.user.name : "", href: "https://account.misis.club/", icon: 'user-astronaut', lastElement: true},
      menuItems: function() {
        var menu = [...this.links];
        if (this.user.authorized) { menu.unshift(this.authorized); }
        else { menu.unshift(this.unauthorized); }
        return menu;
      }
    }
  }
}
</script>

<style>
.nohref a:visited{
    color: black;
}
.nohref a:link{
    color: black;
}
</style>
